import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { BillOfMaterials } from "./bill-of-materials-types";

export const getBillOfMaterials = {
  name: "getBillOfMaterials" as const,
  input: z.object({ billOfMaterialsId: billOfMaterialsIdFormat.schema }),
  output: BillOfMaterials,
};
